import React, { ReactNode } from 'react';
import { Card } from 'react-bootstrap';

interface DeletedBorderCardProps {
  children: ReactNode;
  isDeleted?: boolean;
  className?: string;
}

/**
 * A card component that shows a red left border when the item is deleted
 */
const DeletedBorderCard: React.FC<DeletedBorderCardProps> = ({
  children,
  isDeleted = false,
  className = ''
}) => {
  return (
    <Card className={`mb-4 ${className}`}>
      <div className={`${isDeleted ? "position-relative" : ""}`}>
        {isDeleted && (
          <div
            className="position-absolute top-0 start-0 h-100"
            style={{
              width: "4px",
              backgroundColor: "#dc3545",
              borderTopLeftRadius: "4px",
              borderBottomLeftRadius: "4px",
            }}
          ></div>
        )}
        {children}
      </div>
    </Card>
  );
};

export default DeletedBorderCard;
